import script from "./RestockNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./RestockNotice.vue?vue&type=script&setup=true&lang=js"

import "./RestockNotice.vue?vue&type=style&index=0&id=3fd6fe21&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fd6fe21"]])

export default __exports__